const Menu = [
  {
    name: 'Dashboard',
    translate: 'menu.DASHBOARD',
    icon: 'icon-speedometer',
    path: '/dashboard',
    roles: ['Admin', 'Owner', 'Editor'],
  },
  {
    name: 'Jobs',
    translate: 'menu.JOBS',
    icon: 'icon-handbag',
    path: '/jobs',
    roles: ['Admin', 'Owner', 'Editor'],
  },
  {
    name: 'Applicants',
    translate: 'menu.APPLICANTS',
    icon: 'icon-people',
    path: '/applicants',
    label: { value: null, color: 'warning' },
    roles: ['Admin', 'Owner', 'Editor'],
  },
  {
    name: 'Applications',
    translate: 'menu.APPLICATIONS',
    icon: 'icon-envelope-letter',
    path: '/applications',
    label: { value: 3, color: 'warning' },
    roles: ['Admin', 'Owner', 'Editor'],
  },
  {
    name: 'Calendar',
    translate: 'menu.CALENDAR',
    icon: 'icon-calendar',
    path: '/cldr',
    roles: ['Admin', 'Owner', 'Editor'],
  },
  // {
  //   name: 'Competences',
  //   translate: 'menu.COMPETENCES',
  //   icon: 'icon-rocket',
  //   path: '/competences',
  //   roles: ['Admin', 'Owner', 'Editor'],
  // },
  {
    name: 'Insert Applicant',
    translate: 'menu.INSERT_APPLICANT',
    icon: 'icon-user-follow',
    path: '/insertApplicant',
    roles: ['Admin', 'Owner', 'Editor'],
  },
  {
    name: 'Settings',
    translate: 'menu.SETTINGS',
    icon: 'icon-settings',
    path: '/settings/profile',
    roles: ['Admin', 'Owner', 'Editor'],
  },
  {
    heading: 'For Admins Only',
    roles: ['Admin'],
  },
  {
    name: 'Overview',
    icon: 'icon-arrow-right',
    path: '/overview',
    roles: ['Admin'],
  },
  {
    name: 'User actions',
    icon: 'icon-cup',
    path: '/userActions',
    roles: ['Admin'],
  },
  {
    name: 'Simulator',
    icon: 'icon-arrow-right',
    path: '/simulator',
    roles: ['Admin'],
  },
  {
    name: 'App Pages',
    icon: 'icon-grid',
    roles: ['Admin'],
    submenu: [
      {
        name: 'Error',
        path: '/error',
        roles: ['Admin'],
      },
      {
        name: 'Login',
        path: '/login',
        roles: ['Admin'],
      },
      {
        name: 'Register',
        path: '/register',
        roles: ['Admin'],
      },
      {
        name: 'Recover Password',
        path: '/recover',
        roles: ['Admin'],
      },
      {
        name: 'Reset Password',
        path: '/resetPasswordAppTemp',
        roles: ['Admin'],
      },
    ],
  },
];

export default Menu;
